VjsAdmin.DistrictGroupBulkUploadValidate = (function () {
    const init = function () {
        $('#bulk-uploads-groups').on('click', '.bulk-upload-group-row.selectable', function () {
            const groupname = $(this).attr('data-group-name');
            $(this).find('input[type=radio]').prop('checked', true);
            $(`#bulk-uploads-groups > tbody > tr[data-group-name=${groupname}]`).removeClass('selected not-selected');
            $(this).addClass('selected');
            $(`#bulk-uploads-groups > tbody > tr[data-group-name=${groupname}]`).not(this).addClass('not-selected');

            $(`#bulk-uploads-groups > tbody > tr[data-group-name=${groupname}] :input`).not(this).prop('disabled', true);
            $(this).find('select,input').prop('disabled', false);

            queueButton();
        });

        $('.group_owner').on('click', (e) => {
            e.stopPropagation();
        });

        queueButton();
    };

    const queueButton = function () {
        const numToSelect = $('#queue-button').attr('data-number-of-existing-groups');
        const numSelected = $('#bulk-uploads-groups input[type=radio]:checked').length;
        $('#queue-button').prop('disabled', !(+numToSelect === +numSelected));
    };
    return {
        init,
    };
}());
